<template>
  <v-btn
    :data-cy="dataCy"
    icon="mdi-dots-vertical"
    size="small"
    variant="flat"
    class="menu-dropdown"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MenuActivator',
  props: {
    dataCy: {
      type: String,
      required: false
    }
  }
})
</script>

<style lang="scss" scoped>
.menu-dropdown {
  font-size: 1rem;

  .v-icon {
    --v-icon-size-multiplier: 1;
  }
}
</style>
